/* build: sticky-atc-dedupe 2026-07-22 */
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // The sticky add-to-cart form proxies its submit to the MAIN product form
        // (see lumin-sticky-cart.js). It must NOT also add on its own, or one click
        // adds the item twice. Leave it inert here.
        if (this.classList.contains('sticky-atc')) return;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.error = false;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSectionIds() {
        if (!this.cart) return '';
        return this.cart
          .getSectionsToRender()
          .map((section) => section.id)
          .join(',');
      }

      async fetchCartSections(variantId) {
        const sectionIds = this.getSectionIds();
        if (!sectionIds || !window.routes?.cart_url) return null;

        return fetch(`${window.routes.cart_url}?sections=${sectionIds}`)
          .then((response) => response.json())
          .then((sections) => ({ id: variantId, sections }))
          .catch((error) => {
            console.error(error);
            return null;
          });
      }

      finishSubmit() {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      openCart(response, variantId) {
        if (this.skipCart) {
          // Pricing (free cleanser + free shipping) is handled by Shopify automatic
          // discounts. Just sync the gift line, then go to native checkout.
          const goCheckout = () => {
            window.location = '/checkout';
          };

          if (window.gloweGwp?.sync) {
            window.gloweGwp.sync({ skipSectionRefresh: true })
              .then(() => goCheckout())
              .catch(() => goCheckout());
          } else {
            goCheckout();
          }
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData: response,
        });
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      handleAddError(response, variantId) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: variantId,
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) {
          this.error = true;
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.error = false;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.skipCart = this.form.querySelector('[name=id]')?.dataset.skipCart === 'true';
        const variantId = formData.get('id');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleAddError(response, variantId);
              return;
            }

            this.openCart(response, variantId);

            if (!this.skipCart && window.gloweGwp?.sync) {
              window.gloweGwp.sync().catch((error) => console.error(error));
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.finishSubmit();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        } else if (this.errorMessage) {
          this.errorMessage.textContent = '';
        }
      }
    }
  );
}
